import { render, staticRenderFns } from "./base-setting.vue?vue&type=template&id=a805c2d2&scoped=true"
import script from "./base-setting.vue?vue&type=script&lang=js"
export * from "./base-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a805c2d2",
  null
  
)

export default component.exports